export default "__VITE_ASSET__q9JRaEwp__"